export type Testimonial = {
  id: string
  quote: string
  name: string
  city: string
  role: string
  photo: string
}

export const testimonials: Testimonial[] = [
  {
    id: 'marina',
    quote:
      'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
    name: 'Marina G.',
    city: 'Mar del Plata',
    role: 'Profe de Stretching en Estudio Integral',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/590f5961-4c2a-4d8e-863d-87a9a62fce8e.jpg',
  },
  {
    id: 'agustina',
    quote:
      'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
    name: 'Agustina G.',
    city: 'Santa Fe',
    role: 'Profe de Stretching Grupal',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/1eff1bbc-a146-4a9b-b87d-0e95449e9f1c.jpg',
  },
  {
    id: 'natalia',
    quote:
      'Las clases con progresión real por nivel cambiaron todo. Mis alumnas mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
    name: 'Natalia G.',
    city: 'Mendoza',
    role: 'Profe de Stretching Terapéutico',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/ffc7404d-6011-458b-9294-1ab605cacbea.jpg',
  },
]

export const socialProofAvatars: string[] = [
  'https://cdn.magicpatterns.com/patterns/generated-images/590f5961-4c2a-4d8e-863d-87a9a62fce8e.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/1eff1bbc-a146-4a9b-b87d-0e95449e9f1c.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/ffc7404d-6011-458b-9294-1ab605cacbea.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/af1dc401-ec06-4550-afc2-654a1b00dca0.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/611581b0-9769-41ad-afad-ecd17c78bf02.jpg',
]
